<template>
  <div :class="'vue timparty-badge-counter badge-counter d-flex ' + (altMode ? 'alt' : '')" v-if="badge_count !== null && !is_ended">

      <div class="badge-counter-content mt-2">
        {{ label_text }} <img class="icon-badge" :src="modulePath(altModeImage ? '/js/src/assets/images/icon-black-badge.png' : '/js/src/assets/images/icon-teal-badge.png')"> <strong>{{ badge_count }}&nbsp;{{ __('badge') }}</strong>
      </div>

      <button-badges-modal v-if="!hideInfo" :alt-mode="altMode" :alt-mode-image-prop="altModeImageProp"></button-badges-modal>
  </div>
  <div v-else-if="is_ended" class="mt-4"></div>
</template>

<script>

    /* eslint-disable */

    import moment         from "moment";
    import { mapGetters } from 'vuex'

    import TimPartyMixin from '../mixins/TimPartyMixin';
    import ButtonBadgesModal from './ButtonBadgesModal';

    export default {
      name: 'BadgeCounter',
      mixins: [ TimPartyMixin ],
      components: {  ButtonBadgesModal },
      props: {
        labelText: {
          type: String,
          default: 'Partecipa e ottieni',
        },
        badgeCount: {
          type: String,
          default: null,
        },
        hideInfo: {
          type: Boolean,
          default: true,
        },
        altMode: {
          type: Boolean,
          default: false,
        },
        altModeImageProp: {
          type: Boolean,
          default: null,
        },
        contestUrl: {
          type: String,
          default: '/party-collection',
        },
        endDatePartyColl: {
          type: String,
          default: '20230108235959'
        }

      },
      data: function(){
        return {

          label_text: 'Hai a disposizione',
          badge_count: null,
          altModeImage: null,
          is_ended: false,

        };
      },
      mounted: function(){
        if( this.labelText )
          this.label_text = this.labelText;

        if( this.badgeCount ){
          this.badge_count = this.badgeCount;
        }
        else if( this.userBadgesCount ){
          this.label_text = 'Hai a disposizione';
          this.badge_count = this.userBadgesCount;
        }

        this.altModeImage = this.altModeImageProp === null ? this.altMode : this.altModeImageProp;
        this.isEndedPartyColl();
      },

      methods: {
        isEndedPartyColl: function () {
          let end_date = moment(this.endDatePartyColl, 'YYYYMMDDHHmmss');
          const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
          });

          let today = params.today ? moment(params.today, 'YYYYMMDDHHmmss') : moment();
          this.is_ended = today.isAfter(end_date);
        },
      },
      computed: {
         ...mapGetters([
            'userBadgesCount',
          ])
      },
      watch:{

        badgeCount: function( new_val ){
          this.badge_count = new_val;
        },

        userBadgesCount: function(){

          if(this.badgeCount == null){
            this.label_text = 'Hai a disposizione';
            this.badge_count = this.userBadgesCount;
          }
        },
        altModeImage: function () {}
      }
    }
  </script>


